import { Typography } from '@branchjs/neo-components';
import React from 'react';
import Link from '../../../../common/components/core/Link';
import { ImageService } from '../../../../main/services/ImageService/ImageService';
import { SignupPanelSection } from '../SignupPanelSection/SignupPanelSection';
import { useStyles } from './SignupPanel.styles';

export function SignupPanel() {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <div className={classes.header}>
        <Typography className={classes.headerText} variant={'h3'}>
          Try for 30 days
        </Typography>
      </div>
      <div>
        <SignupPanelSection
          title="Build your business without breaking the bank"
          imageUrl="/static/images/loggedout/card-pos.svg"
          imageAlt="People icon"
        >
          <Typography className={classes.bodyText} variant="body1">
            Users with fewer than 10,000 monthly active users (MAU) pay nothing with our Self-serve Platform and, as you
            grow, pay just $5 per 1,000 MAU.
          </Typography>
        </SignupPanelSection>
        <SignupPanelSection
          title="We're your partner throughout your growth"
          imageUrl="/static/images/loggedout/people.svg"
          imageAlt="People icon"
        >
          <Typography className={classes.bodyText} variant="body1">
            Extensive capabilities available in our Enterprise Platform tailor to every mobile growth use case, for even the
            largest companies.
          </Typography>
        </SignupPanelSection>
        <SignupPanelSection>
          <Link
            className="loggedout--signup-panel-link"
            href="https://www.branch.io/contact-sales/"
            testid="signup-panel-sales-link"
          >
            Chat with our sales team about how we can support your enterprise brand.
            <img src={ImageService.getImageUrl('/static/images/loggedout/ic_right-arrow.svg')} />
          </Link>
        </SignupPanelSection>
      </div>
    </div>
  );
}
